import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import Textarea from 'react-textarea-autosize';
import { injectIntl } from 'react-intl';

class ShareModalComment extends PureComponent {
  render() {
    const {
      intl,
      comment,
      saving,
      handleChange,
    } = this.props;

    return (
      <div className="share-comment">
        <Label for="inpShareComment">
          {intl.formatMessage({ defaultMessage: 'Comment' })}
        </Label>
        <Textarea
          className="form-control"
          name="shareComment"
          id="inpShareComment"
          placeholder={intl.formatMessage({ defaultMessage: 'Add comment (optional)' })}
          value={comment}
          disabled={saving}
          onChange={handleChange}
        />
      </div>
    );
  }
}

ShareModalComment.propTypes = {
  intl: PropTypes.object.isRequired,
  comment: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default injectIntl(ShareModalComment);
